import createApiMethods from '@/api/createApiMethods';
import initializeAxios from './axiosSetup';
import { axiosRequestConfiguration } from './config';

export const axiosInstance = initializeAxios(axiosRequestConfiguration);

const api = createApiMethods(axiosInstance);

export default api;
